import styled from 'styled-components'

import { Button as AntButton } from 'src/components/Ant'

export const Breadcrumbs = styled.div`
  padding: 12px 0 0 12px;
  background-color: white;
`

export const Button = styled(AntButton)`
  margin-left: 0.5rem;
`

export const Content = styled.div`
  margin: 8px 16px 24px 16px;
`

export const DrawerFooterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  > div > div {
    margin-left: 1rem;
  }
`
